<template>
  <div>
    <div class="d-flex justify-content-between">
      <div class="row">
        <div class="col-3">
          <div class="col-12">
            <SignaturesContainer
              :signatures="signatures"
              v-model="signatureSelected"
              placeholder="Buscar Firma"
            />
          </div>
          <div
            class="col-12 mt-10"
            v-if="actions && actions.length > 0"
          >
            <SignaturesContainer
              :signatures="actions"
              v-model="signatureSelected"
              placeholder="Buscar acciones"
            />
          </div>
        </div>
        <div class="col-9">
          <PdfViewport
            :default-page="1"
            :path="step.mainFile.path"
            :name="step.mainFile.name"
            :signatures="Object.values(step.signaturesDropped)"
            @loaded="$emit('loaded')"
            @page-click="onSignatureDropped"
            :closable-sign="true"
            @signature-delete="onSignatureDelete"
            @signature-drag-end="onSignatureDragEnd"
            :signature-width="signatureWidth"
            :signature-height="signatureHeight"
            :signature-type="signatureType"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import WizardStep from '@/febos/chile/dnt/mixins/WizardStep';
import RolTypes from '@/febos/chile/dnt/mixins/RolTypes';
import SignaturesContainer from '@/febos/chile/approvals/wizardFlow/components/SignaturesContainer';
import PdfViewport from '@/febos/global/pdf/components/PdfViewport';
import { SIGNATURE_TYPES } from '@/febos/global/pdf/config';
import StepTypes from '@/febos/chile/dnt/mixins/StepTypes';

const SIGNATURE_WIDTH = 150;
const SIGNATURE_HEIGHT = 50;

export default {
  mixins: [
    WizardStep
  ],
  components: {
    SignaturesContainer,
    PdfViewport
  },
  data() {
    return {
      isDroppingSignature: false,
      signatureSelected: undefined,
      actionsSelected: undefined,
      step: {
        signaturesDropped: {},
        ...this.draft,
      },
      signatureWidth: SIGNATURE_WIDTH,
      signatureHeight: SIGNATURE_HEIGHT,
      signatureType: SIGNATURE_TYPES.DraggableSignature
    };
  },
  computed: {
    signatures() {
      return this.step.steps
        .filter((step) => (
          step.rolType === RolTypes.SIGNER
            && !this.step.signaturesDropped[step.responsibleId]
        ))
        .filter((step) => (
          step.desatendido !== true
        ))
        .map(({
          responsibleName, responsibleId, stepType, x, y, page
        }) => ({
          name: responsibleName,
          id: responsibleId,
          stepType,
          x,
          y,
          page
        }));
    },
    actions() {
      if (!this.step?.actions) {
        return [];
      }
      return this.step?.actions.map(({ id, action, ...resto }) => ({
        name: action,
        id: `${id}-${action}`,
        ...resto,
        isAction: true
      })).filter(({ id, positionRequired }) => (
        positionRequired && !this.step.signaturesDropped[id]
      ));
    }
  },
  watch: {
    signatureSelected(newValue, prevValue) {
      if (this.isDroppingSignature) {
        this.isDroppingSignature = false;
        return;
      }

      if (!newValue && prevValue) {
        const {
          [prevValue.id]: ignored,
          ...cleanSignaturesDropped
        } = this.step.signaturesDropped;
        this.step.signaturesDropped = cleanSignaturesDropped;
      }
    }
  },
  methods: {
    onSignatureDropped({ x, y }, page) {
      if (!this.signatureSelected) {
        return;
      }
      this.step.signaturesDropped = {
        ...this.step.signaturesDropped,
        [this.signatureSelected.id]: {
          ...this.signatureSelected,
          x,
          y,
          page
        }
      };
      this.isDroppingSignature = true;
      this.signatureSelected = undefined;
    },
    onSignatureDelete(signature) {
      this.$delete(this.step.signaturesDropped, signature.id);
    },
    onSignatureDragEnd({ x, y }, signature) {
      this.step.signaturesDropped = {
        ...this.step.signaturesDropped,
        [signature.id]: {
          ...signature,
          x,
          y
        }
      };
    },
    getStepData() {
      return {
        ...this.step
      };
    },
    async isValid() {
      const signatures = this.signatures
        .filter((signature) => signature.stepType !== StepTypes.OFFICE);
      if (signatures.length) {
        this.$bvToast.toast(
          'Debes ubicar todas las firmas!',
          {
            title: 'Error',
            variant: 'danger',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 2000
          }
        );
        return false;
      }
      if (this.actions.length) {
        this.$bvToast.toast(
          'Debes ubicar todas las acciones!',
          {
            title: 'Error',
            variant: 'danger',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 2000
          }
        );
        return false;
      }
      return true;
    }
  }
};

</script>
